// ======================================================================
// File Name       : SuperuserEnterpriseRoleTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getSuperuserEnterpriseRoleList } from '../../actions/SuperuserEnterpriseRoleAction';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import { SUPERUSER_ENTERPRISE_ROLE, USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import * as Path from '../../constants/PathConstants';
import { RETURN_MAX_NUM_1000, SELECT_TARGET_DATA } from '../../constants/index';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { SYSTEM_CREATE_FLAG } from '../../constants/CommonConstants';

class SuperuserEnterpriseRoleTopContainer extends React.Component {
  /**
     * Constructor function of component
     * @param {*} props
     */
  constructor(props) {
    super(props);
    this.state = {
      authorityInfo: {
        roleList: [],
      },
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM_1000,
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.getSuperuserEnterpriseRoleList = this.getSuperuserEnterpriseRoleList.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }

  /**
     * Life cycle function of component
     */
  componentDidMount() {
    this.onSearchData();
  }

  static getDerivedStateFromProps(nextProps, state) {
    const { superuserEnterpriseRole: { authorityInfo } } = nextProps;
    if (state.authorityInfo !== authorityInfo) {
      return {
        ...state,
        authorityInfo,
      };
    }
    return state;
  }

  onSearchData() {
    this.setState(
      {
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM_1000,
      },
      () => this.getSuperuserEnterpriseRoleList(),
    );
  }

  /**
     * Get authority list
     *
     * @param {integer} selectTargetData
     */
  getSuperuserEnterpriseRoleList(selectTargetData) {
    const param = {
      startPosition: this.state.startPosition,
      returnMaxNum: this.state.returnMaxNum,
    };
    this.props.dispatch(getSuperuserEnterpriseRoleList(param));
  }

  /**
     * Pagination
     * @param {*} page
     */
  getStartEndData(startPosition) {
    this.setState(
      {
        startPosition,
      },
      () => {
        this.getSuperuserEnterpriseRoleList();
      },
    );
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  /**
     * Render function of component
     */
  render() {
    const authorityList = this.state.authorityInfo.roleList.map(
      (authority, index) => {
        let btnName = '詳細';
        let className = 'link-detail';
        const { superuserEnterpriseRoleSecernId, superuserEnterpriseRoleName, systemCreateFlag } = authority;
        if (
          systemCreateFlag === SYSTEM_CREATE_FLAG.USER // Step 11.0.0
        ) {
          btnName = '詳細・編集';
          className = 'link-detail-edit';
        }
        const link = `/${Path.SUPERUSER_ENTERPRISE_ROLE}/${superuserEnterpriseRoleSecernId}`;
        return (
          <tr key={superuserEnterpriseRoleSecernId} onMouseEnter={() => this.handleMouseEnter(index)} onMouseLeave={() => this.handleMouseLeave()}>
            <td>
              {superuserEnterpriseRoleName}
            </td>
            <td className="text-center">
              <CustomLink
                className={`margin-right-7 ${className}`}
                to={link}
                text={btnName}
              />
            </td>
          </tr>
        );
      },
    );
    const canAccessRegister = canAccessRoute(FUNCTION.SUPERUSER_ENTERPRISE_ROLE_REGISTER);
    return (
      <div>
        <Col className="padding-left-right-clear display-flex justify-content-end margin-bottom-10">
          {canAccessRegister && (
            <CustomLink
              className="margin-right-7 btn-register"
              to={Path.SUPERUSER_ENTERPRISE_ROLE_REGISTER}
              text="企業ロール追加"
              icon={ICON.REGIST_NEW_ROLE}
            />
          )}
        </Col>
        <Col className="padding-left-right-clear">
          <Form className='form-horizontal'>
            <Table striped hover>
              <thead>
                <tr>
                  <th>ロール名</th>
                  <th width="150">
                    操作
                  </th>
                </tr>
              </thead>
              <tbody>
                {authorityList}
              </tbody>
            </Table>
          </Form>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ superuserEnterpriseRole: state.superuserEnterpriseRole },
});

export default connect(mapStateToProps)(SuperuserEnterpriseRoleTopContainer);
